import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";

import FilterForm from "app/Components/FilterForm/FilterForm";
import { incidentFilterFields } from "./CONSTANTS";
import { getDepartment } from "app/_services/UserManagement/DepartmentService";
import { useArea } from "app/_helpers/hooks";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { UserService } from "app/_services/UserService/UserService";
import { getAuthUser, LOGGED_IN_USER_SITE_ID } from "./Helper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";

export default function IncidentFilters({
  form,
  onChange,
  onReset,
  setForm,
  isViewIncident,
  fields,
}) {
  const [state, setState] = useState({
    departments: [],
    subAreas: [],
    initialActivity: [],
    activity: [],
    subActivities: [],
    sites: [],
    roSites: [],
  });

  const [area, areaOption] = useArea();
  const [roList, setRoList] = useState([]);
  // const [activity, setActivity] = useState([]);
  useEffect(() => {
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;
      const userSiteId = LOGGED_IN_USER_SITE_ID();
      const auth_user = getAuthUser();

      setRoList(
        response.data
          .filter(
            (user) =>
              (user?.accessPermissions || []).filter(
                (d) => d.permission === "reporterOfficer" && d.permissionValue === "1"
              ).length &&
              (+auth_user?.role?.roleLable === 1 ||
                +user?.employee?.ehsSite?.id === userSiteId)
          )
          .map((user) => ({
            label: userDropdownLabel(user),
            id: user.id,
            value: user.id,
          }))
      );
    });

    getDepartment("filter[status]=1").then((response) => {
      if (!response?.data) return;
      setState((prev) => ({
        ...prev,
        departments: response.data.departments.map((row) => ({
          label: row.name,
          value: row.id,
        })),
      }));
    });

    getAllActivity().then((response) => {
      if (!response?.data) return;
      setState((prev) => ({
        ...prev,
        initialActivity: response?.data,
        activity: response.data.map((row) => ({ label: row.name, value: row.id })),
      }));
    });

    getAllSites("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setState((prev) => ({
        ...prev,
        //initialActivity: response?.data,
        sites: response.data.map((row) => ({ label: row.name, value: row.id })),
        roSites: response.data
          .filter((d) => d.siteType === 2)
          .map((row) => ({ label: row.name, value: row.id })),
      }));
    });
  }, []);

  const finalFields = useMemo(
    () =>
      (isViewIncident ? fields : incidentFilterFields).map((f) => {
        const field = { ...f };

        switch (field.name) {
          case "departmentId":
            field.options = state.departments;
            break;
          case "areaId":
            field.options = areaOption;
            break;
          case "subAreaId":
            field.options = state.subAreas;
            break;
          case "activityId":
            field.options = state.activity;
            break;
          case "subActivityId":
            field.options = state.subActivities;
            break;
          case "siteId":
            field.options = state.sites;
            break;
          case "roId":
            field.options = state.roSites;
            break;
          case "reportedBy":
            field.options = roList;
            break;

          default:
            break;
        }

        return field;
      }),
    [
      isViewIncident,
      fields,
      state.departments,
      state.subAreas,
      state.activity,
      state.subActivities,
      state.sites,
      state.roSites,
      areaOption,
      roList,
    ]
  );

  useLayoutEffect(() => {
    setForm((prev) => ({ ...prev, subAreaId: "" }));
  }, [form.areaId, setForm]);

  useLayoutEffect(() => {
    setForm((prev) => ({ ...prev, subActivityId: "" }));
  }, [form.activityId, setForm]);

  useEffect(() => {
    if (!form.areaId) return setState((prev) => ({ ...prev, subAreas: [] }));

    setState((prev) => ({
      ...prev,
      subAreas:
        area
          .find((d) => d.id === form.areaId)
          ?.subAreaOfOperation.map((d) => ({ name: d.name, value: d.id.toString() })) ||
        [],
    }));
  }, [area, form.areaId]);

  useEffect(() => {
    if (!form.activityId) return setState((prev) => ({ ...prev, subActivities: [] }));

    setState((prev) => ({
      ...prev,
      subActivities:
        state.initialActivity
          .find((d) => d.id === form.activityId)
          ?.subActivity.map((d) => ({ name: d.name, value: d.id.toString() })) || [],
    }));
  }, [form.activityId, state.initialActivity]);

  // console.log("state", state);

  const handleDateRange = (dates) => {
    console.log("dates", dates);
    onChange({
      target: {
        name: "startDate",
        value: dates.startDate
          ? moment(new Date(dates.startDate)).format("YYYY-MM-DD")
          : null,
      },
    });
    onChange({
      target: {
        name: "endDate",
        value: dates.endDate
          ? moment(new Date(dates.endDate)).format("YYYY-MM-DD")
          : null,
      },
    });
  };
  return (
    <div className="my-3">
      <FilterForm
        fields={finalFields}
        form={form}
        onChange={onChange}
        onReset={onReset}
        handleDateRange={handleDateRange}
        startDate={form?.startDate || null}
        endDate={form?.endDate || null}
      />
    </div>
  );
}
